'use client';

import React, { Suspense } from 'react';
import StaffLoginForm from '../StaffLoginForm';

export default function VadybaLoginPage() {
  return (
    <Suspense
      fallback={
        <div className="min-h-screen bg-[#f0f4f8] flex items-center justify-center">
          <div className="w-8 h-8 border-2 border-[#1e3a5f] border-t-transparent rounded-full animate-spin" />
        </div>
      }
    >
      <StaffLoginForm />
    </Suspense>
  );
}
